import { Modal, Box, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ShiftRemarksModal = ({ open, onClose, remark }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          maxHeight: "80vh",
          bgcolor: "#fff",
          boxShadow: 24,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #eee",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Remarks
          </Typography>

          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "pre-wrap",
              color: "#444",
              lineHeight: 1.6,
            }}
          >
            {remark || "No Remarks Available"}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShiftRemarksModal;